import { FilterConfig } from '../../../components/Tables/advancedRecord/FilterBar';

export const getDteInvalidationLogFilters = (): FilterConfig[] => {
  return [
    {
      name: 'generationCode',
      label: 'Código de Generación',
      type: 'text',
      colSpan: 2,
    },
  ];
};
